import './404.scss';

function NotFound() {
    return (
        <div className="404">
            The page you are looking for does not exist
        </div>
    )
}

export default NotFound;